module.exports = __webpack_public_path__ + "img/2.1179cd11.jpg";